<template>
  <div class="row">
    <loading  :active.sync="isLoading" 
              :can-cancel="false" 
              :is-full-page="true">
    </loading>
    <div class="col-md-12">
      <h4 class="title" style="margin-top:0px">Ajout de client</h4>
    </div>
    <div class="col-md-12 card">
      <div class="card-body">
        <!-- INFORMATIONS -->
        <hr data-content="Informations" class="hr-text">
        <div class="row">
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Négociateur :</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" filterable v-model="client.id_negociateur" placeholder="Négociateur rattaché">
                <el-option
                  label="Pas de négociateur rattaché"
                  :value="null"
                  selected>
                </el-option>
                <el-option
                  v-for="item in all_clients"
                  :key="item.cid"
                  :label="item.company"
                  :value="Number(item.cid)">
                </el-option>
              </el-select>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Enseigne :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8">
                <el-input v-model="client.company"/>
                <transition name="fade">
                  <div v-if="MissingInput.company" class="alert alert-danger alert-missing" role="alert">
                    L'enseigne est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row" v-if="rid==1" >
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Commercial :</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-model="client.coid" placeholder="Commercial rattaché">
                <el-option
                  label="Pas de commercial rattaché"
                  :value="null"
                  selected>
                </el-option>
                <el-option
                  v-for="item in all_contact"
                  :key="item.coid"
                  :label="item.firstname+' '+item.lastname"
                  :value="Number(item.coid)">
                </el-option>
              </el-select>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Type de compte :</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-model="client.type_client" placeholder="Type de compte">
                <el-option
                  v-for="item in all_nature_client"
                  :key="item.ncid"
                  :label="item.nom"
                  :value="Number(item.ncid)"
                  >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">SIRET :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input v-model="client.siret"/>
                <transition name="fade">
                  <div v-if="MissingInput.siret" class="alert alert-danger alert-missing" role="alert">
                    Le SIRET est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Téléphone :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8">
                <el-input  v-model="client.phone"/>
                <transition name="fade">
                  <div v-if="MissingInput.phone" class="alert alert-danger alert-missing" role="alert">
                    Le téléphone ne peut être vide.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Mail :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input v-model="client.email"/>
                <transition name="fade">
                  <div v-if="MissingInput.email" class="alert alert-danger alert-missing" role="alert">
                    Le mail ne peut être vide.
                  </div>
                </transition>
                <transition name="fade">
                  <div v-if="badMail" class="alert alert-danger alert-missing" role="alert">
                    L'adresse mail n'est pas valide.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Mot de passe :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input type="password" show-password v-model="client.password_to_hash"/>
                <transition name="fade">
                  <div v-if="MissingInput.password" class="alert alert-danger alert-missing" role="alert">
                    Le mot de passe est manquant.
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <!-- /INFORMATIONS -->
        <!-- COORDONNEES -->
        <hr data-content="Coordonnées" class="hr-text">
        <div class="row">
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Adresse :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input v-model="client.address"/>
                <transition name="fade">
                  <div v-if="MissingInput.address" class="alert alert-danger alert-missing" role="alert">
                    L'adresse est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Complément :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input v-model="client.complement"/>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Ville :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" >
                <el-input v-model="client.city"/>
                <transition name="fade">
                  <div v-if="MissingInput.city" class="alert alert-danger alert-missing" role="alert">
                    La ville est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Code postal :</div>
              <div class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8">
                <el-input v-model="client.zipcode"/>
                <transition name="fade">
                  <div v-if="MissingInput.zipcode" class="alert alert-danger alert-missing" role="alert">
                    Le code postal est manquant.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Pays :</div>
              <el-select class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" filterable v-model="client.country" placeholder="Pays">
                <el-option
                  v-for="item in countries"
                  :key="item.name"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-lg-6 client_block">
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Contact Princ :</div>
              <div class="my-1 information-line-text col-xl-4 col-md-4 col-sm-4">
                <el-input v-model="client.firstname"/>
                <transition name="fade">
                  <div v-if="MissingInput.userFirstname" class="alert alert-danger alert-missing" role="alert">
                    Le prénom ne peut être vide.
                  </div>
                </transition>
              </div>
              <div class="my-1 information-line-text col-xl-4 col-md-3 col-sm-4">
                <el-input  v-model="client.lastname"/>
                <transition name="fade">
                  <div v-if="MissingInput.userLastname" class="alert alert-danger alert-missing" role="alert">
                    Le nom ne peut être vide.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="my-2 information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left">Fonction :</div>
              <el-input class="my-1 information-line-text col-xl-8 col-md-7 col-sm-8" v-model="client.fonction_contact_princ"/>
            </div>
          </div>
        </div>
        <!-- /COORDONNEES -->
        <!-- REMISES -->
        <hr data-content="Prix par fioles" class="hr-text">
        <div class="row">
          <div class="col-lg-4 client_block">
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Pur Fruit 10ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisepurfruit10">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisepurfruit10" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Pur Fruit 10ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Pur Fruit 20ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisepurfruit">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisepurfruit" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Pur Fruit 20ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Pur Fruit 50ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisepurfruit50">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisepurfruit50" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Pur Fruit 50ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Prêt à vaper 10ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisepav">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisepav" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le prêt à vaper est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Prêt à vaper 50ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisepav50">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisepav50" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Prêt à Vaper 50ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="col-lg-4 client_block">
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Concentrés 10ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remiseconcentre">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remiseconcentre" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Concentré 10ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Concentrés 60ml :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remiseconcentre50">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remiseconcentre50" class="alert alert-danger alert-missing" role="alert">
                    La remise pour le Concentré 50ml est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Arômes:</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisearome">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisearome" class="alert alert-danger alert-missing" role="alert">
                    La remise pour l'Arôme est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Additifs :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remiseadditif">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remiseadditif" class="alert alert-danger alert-missing" role="alert">
                    La remise pour l'Additif est manquante.
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <div class="col-lg-4 client_block">
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Bases :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisebase">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisebase" class="alert alert-danger alert-missing" role="alert">
                    La remise pour la Base est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Boosters 20 & 18mg :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisebooster">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisebooster" class="alert alert-danger alert-missing" role="alert">
                    La remise pour les Boosters 20mg & 18mg est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Booster 9mg :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisebooster9">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisebooster9" class="alert alert-danger alert-missing" role="alert">
                    La remise pour les Boosters 9mg est manquante.
                  </div>
                </transition>
              </div>
            </div>
            <div class="row">
              <div class="information-line-name col-xl-4 col-md-5 col-sm-4 text-sm-right text-left my-2">Booster 0mg :</div>
              <div class="information-line-text col-xl-8 col-md-7 col-sm-8"> 
                <el-input class="my-1" v-model="client.remisebooster0">
                  <template slot="append">€</template>
                </el-input>
                <transition name="fade">
                  <div v-if="MissingInput.remisebooster0" class="alert alert-danger alert-missing" role="alert">
                    La remise pour les Boosters 0mg est manquante.
                  </div>
                </transition>
              </div>
            </div>
          </div>
        </div>
        <!-- /REMISES -->
        <!-- OPTIONS -->
        <hr data-content="Options" class="hr-text" v-if="rid==1" >
        <div class="row" v-if="rid==1" >
          <div class="col-lg-4">
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.produitlitre" label="Produit au litre" border></el-checkbox>
            </div>
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.withouttva" label="Ne pas facturer la TVA" border></el-checkbox>
            </div>
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.reseau" label="Réseau" border></el-checkbox>
            </div>
          </div>
          <div class="col-lg-4 ">
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.fdpgratuit" label="Frais de port offert" border></el-checkbox>
            </div>
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.franco100" label="Franco à partir de 100€" border></el-checkbox>
            </div>
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.newsletter" label="Inscription à la newsletter" border></el-checkbox>
            </div>
          </div>
          <div class="col-lg-4 " >
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.showinmap" label="Affichage carte revendeurs" border></el-checkbox>
            </div>
            <div class="row">
              <el-checkbox class="mx-auto" v-model="client.paiementvirement" label="Paiement par virement" border></el-checkbox>
            </div>
          </div>
        </div>
        <!-- /OPTIONS -->
        <!-- BTN SAVE -->
        <hr data-content="Valider" class="hr-text">
        <div class="row">
          <el-button @click="saveClient()" type="success" class="btn-action col-lg-12">Créer le client</el-button>
        </div>
        <!-- /BTN SAVE -->
      </div>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue'
  import {Button, ButtonGroup, Option, Select, Input, Checkbox} from 'element-ui'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'
  import VueJwtDecode from 'vue-jwt-decode'
  import Country from './country'
  Vue.use(Button)
  Vue.use(ButtonGroup)
  Vue.use(Option)
  Vue.use(Select)
  Vue.use(Input)
  Vue.use(Checkbox)
  export default {
    components: {
      Loading
    },
    props: {

    },
    computed: {
      
    },
    data() {
      return {
        isLoading: true,
        cid: this.$route.params.cid,
        client: {
          id_negociateur: 0,
          company: '',
          coid: 0,
          type_client: 0,
          siret: '',
          phone: '',
          email: '',
          password_to_hash: '',
          address: '',
          complement: '',
          city: '',
          zipcode: '',
          country: 'France',
          firstname: '',
          lastname: '',
          remisepurfruit10: 0,
          remisepurfruit: 0,
          remisepurfruit50: 0,
          remisepav: 0,
          remisepav50: 0,
          remiseconcentre: 0,
          remiseconcentre50: 0,
          remisearome: 0,
          remiseadditif: 0,
          remisebase: 0,
          remisebooster: 0,
          remisebooster9: 0,
          remisebooster0: 0,
          produitlitre: false,
          withouttva: false,
          reseau: false,
          fdpgratuit: false,
          franco100: false,
          newsletter: false,
          showinmap: false,
          paiementvirement: false,
          fonction_contact_princ: ''
        },
        edition: false,
        rid: VueJwtDecode.decode(localStorage.getItem('token')).id.rid,
        countries: Country,
        MissingInput: {
          company: 0,
          siret: 0,
          address: 0,
          city: 0,
          zipcode: 0,
          userFirstname: 0,
          userLastname: 0,
          phone: 0,
          email: 0,
          password: 0,
          remisepurfruit10: 0,
          remisepurfruit: 0,
          remisepurfruit50: 0,
          remisepav: 0,
          remisepav50: 0,
          remiseconcentre: 0,
          remiseconcentre50: 0,
          remisearome: 0,
          remiseadditif: 0,
          remisebase: 0,
          remisebooster: 0,
          remisebooster9: 0,
          remisebooster0: 0,
        },
        badMail: 0,
        all_clients: [],
        all_contact: [],
        all_nature_client: [],
      }
    },
    computed: {
      etatcomptable() {
        if(this.client.etat_comptable != "OK") {
          return "text-danger"
        } else {
          return "text-success"
        }
      }
    },
    methods: {
      async saveClient() {
        if(this.checkIfEmpty()) {
          this.notifyVue('top','center', 'danger', 'Il manque des champs obligatoire! 😱', 'fa fa-thumbs-down')
          return; 
        }
        if(this.ValidateEmail()) {
          this.notifyVue('top','center', 'danger', 'L\'email n\'est pas valide! 😱', 'fa fa-thumbs-down')
          return; 
        }

        this.loading = true;
        
        if(this.rid == 2) {
          this.client.coid = "connectedone"
        }
        let client_to_put = this.client;

        const params = this.JSON_to_URLEncoded(client_to_put);
        const response_user = await fetch(this.$api_url+'/users', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
          },
          body: params
        });
        const self = this;
        const json_user = await response_user.json();
        if("id" in json_user) {
          self.log_api("success",'POST /users',params, json_user)
          //SUCCESS POST USER
          client_to_put.uid = json_user.id;
          const params_client = this.JSON_to_URLEncoded(client_to_put);
          const response_client = await fetch(this.$api_url+'/clients', {
            method: 'POST',
            credentials: 'include',
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: params_client
          });
          const json_client = await response_client.json();
          if("id" in json_client) {
            self.log_api("success",'POST /clients',params_client, json_client)
            //SUCCESS POST CLIENT
            client_to_put.title = "Adresse principale";
            client_to_put.mapactive = client_to_put.showinmap;
            client_to_put.siege = 1;
            const params_address = this.JSON_to_URLEncoded(client_to_put);
            const response_address = await fetch(this.$api_url+'/adresses', {
              method: 'POST',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              body: params_address
            });
            const json_address = await response_address.json();
            if("id" in json_address) {
              self.log_api("success",'POST /adresses',params_address, json_address)
              //SUCCESS POST ADDRESS
              this.notifyVue('top','center', 'success', 'Client ajouté! 😄', 'fa fa-thumbs-up')
              this.$router.push({ name: 'Clients' })
            } else {
               self.log_api("error",'POST /adresses',params_address, json_address)
              //ERROR POST ADDRESS
              this.notifyVue('top','center', 'danger', 'Problème lors de la création! 😱', 'fa fa-thumbs-down')
              const params_delete_user_address = this.JSON_to_URLEncoded({uid: json_user.id});
              const DELETE_users_address = await fetch(this.$api_url+'/users', {
                method: 'DELETE',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: params_delete_user_address
              });
              const json_delete_user = await DELETE_users_address.json();
              if("rows" in json_delete_user) {
                self.log_api("success",'DELETE /users', '', json_delete_user)
                //SUCCESS DELETE USER
                const params_delete_client_address = this.JSON_to_URLEncoded({cid: json_client.id});
                const DELETE_clients_address = await fetch(this.$api_url+'/clients', {
                  method: 'DELETE',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                  },
                  body: params_delete_client_address
                });
                const json_delete_client = await DELETE_clients_address.json();
                if("rows" in json_delete_client) {
                  self.log_api("success",'DELETE /clients', '', json_delete_client)
                  //SUCCESS DELETE CLIENT
                }
              }
            }
          } else {
            self.log_api("error",'POST /clients',params_client, json_client)
            //ERROR POST CLIENT
            this.notifyVue('top','center', 'danger', 'Problème lors de la création! 😱', 'fa fa-thumbs-down')
            const params_delete_user = this.JSON_to_URLEncoded({uid: json_user.id});
            const DELETE_users = await fetch(this.$api_url+'/users', {
              method: 'DELETE',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
              },
              body: params_delete_user
            });
            const json_delete_user = await DELETE_users.json();
            if("rows" in json_delete_user) {
              self.log_api("success",'DELETE /users', '', json)
              //SUCCESS DELETE USER
            }
          } 
        } else {
          self.log_api("error",'POST /users',params, json_user)
          //ERROR POST USER
          this.notifyVue('top','center', 'danger', 'Problème lors de la modification! 😱', 'fa fa-thumbs-down')
        } 
        
        this.loading = false;
      },
      async initAllVar() {
        this.client.id_negociateur = null
        this.client.coid = null
        this.client.type_client = 1
        this.client.country = "France"
        
        const self = this;
        const response = await fetch(this.$api_url+'/clients/', {
          method: 'GET',
          credentials: 'include',
        });
        if(response.ok) { 
          const json = await response.json();
          if(json.code != 409) {
            self.log_api("success",'GET /clients/', '', json)
            this.all_clients = json
          }
        }
        const response2 = await fetch(this.$api_url+'/contacts/', {
          method: 'GET',
          credentials: 'include',
        });
        if(response2.ok) { 
          const json = await response2.json();
          if(json.code != 409) {
            self.log_api("success",'GET /contacts/', '', json)
            this.all_contact = json
          }
        }
        const response3 = await fetch(this.$api_url+'/clients/nature_client', {
          method: 'GET',
          credentials: 'include',
        });
        if(response3.ok) { 
          const json = await response3.json();
          if(json.code != 409) {
            self.log_api("success",'GET /clients/nature_client', '', json)
            this.all_nature_client = json
          }
        }
         const response4 = await fetch(this.$api_url+'/produits/remises', {
          method: 'GET',
          credentials: 'include',
        });
        if(response4.ok) { 
          const json = await response4.json();
          if(json.code != 409) {
            self.log_api("success",'GET /produits/remises', '', json)
            this.client.remisepurfruit10 = json.remises.purfruit10
            this.client.remisepurfruit = json.remises.purfruit
            this.client.remisepurfruit50 = json.remises.purfruit50
            this.client.remisepav = json.remises.pav
            this.client.remisepav50 = json.remises.pav50
            this.client.remiseconcentre = json.remises.concentre
            this.client.remiseconcentre50 = json.remises.concentre50
            this.client.remisearome = json.remises.arome
            this.client.remiseadditif = json.remises.additif
            this.client.remisebase = json.remises.base
            this.client.remisebooster = json.remises.booster
            this.client.remisebooster9 = json.remises.booster9
            this.client.remisebooster0 = json.remises.booster0
          }
        }
        this.isLoading = false
      },
      notifyVue (verticalAlign, horizontalAlign, color, message, icon) {
        this.$notify(
          {
            message: message,
            icon: icon,
            horizontalAlign: horizontalAlign,
            verticalAlign: verticalAlign,
            type: color
          })
      },
      JSON_to_URLEncoded(obj, prefix) {
        var str = [],
          p;
        for (p in obj) {
          if (obj.hasOwnProperty(p)) {
            var k = prefix ? prefix + "[" + p + "]" : p,
              v = obj[p];
            str.push((v !== null && typeof v === "object") ?
              this.JSON_to_URLEncoded(v, k) :
              encodeURIComponent(k) + "=" + encodeURIComponent(v));
          }
        }
        return str.join("&");
      },
      checkIfEmpty() {
        this.MissingInput.company = (this.client.company === undefined || this.client.company == "" ? 1 : 0)
        this.MissingInput.siret = (this.client.siret === undefined || this.client.siret == "" ? 1 : 0)
        this.MissingInput.address = (this.client.address === undefined || this.client.address == "" ? 1 : 0)
        this.MissingInput.city = (this.client.city === undefined || this.client.city == "" ? 1 : 0)
        this.MissingInput.zipcode = (this.client.zipcode === undefined || this.client.zipcode == "" ? 1 : 0)
        this.MissingInput.userFirstname = (this.client.firstname === undefined || this.client.firstname == "" ? 1 : 0)
        this.MissingInput.userLastname = (this.client.lastname === undefined || this.client.lastname == "" ? 1 : 0)
        this.MissingInput.phone = (this.client.phone === undefined || this.client.phone == "" ? 1 : 0)
        this.MissingInput.email = (this.client.email === undefined || this.client.email == "" ? 1 : 0)
        this.MissingInput.password = (this.client.password_to_hash === undefined || this.client.password_to_hash == "" ? 1 : 0)
        this.MissingInput.remisepurfruit10 = (this.client.remisepurfruit10 === undefined || this.client.remisepurfruit10 == "" ? 1 : 0)
        this.MissingInput.remisepurfruit = (this.client.remisepurfruit === undefined || this.client.remisepurfruit == "" ? 1 : 0)
        this.MissingInput.remisepurfruit50 = (this.client.remisepurfruit50 === undefined || this.client.remisepurfruit50 == "" ? 1 : 0)
        this.MissingInput.remisepav = (this.client.remisepav === undefined || this.client.remisepav == "" ? 1 : 0)
        this.MissingInput.remisepav50 = (this.client.remisepav50 === undefined || this.client.remisepav50 == "" ? 1 : 0)
        this.MissingInput.remiseconcentre = (this.client.remiseconcentre === undefined || this.client.remiseconcentre == "" ? 1 : 0)
        this.MissingInput.remiseconcentre50 = (this.client.remiseconcentre50 === undefined || this.client.remiseconcentre50 == "" ? 1 : 0)
        this.MissingInput.remisearome = (this.client.remisearome === undefined || this.client.remisearome == "" ? 1 : 0)
        this.MissingInput.remiseadditif = (this.client.remiseadditif === undefined || this.client.remiseadditif == "" ? 1 : 0)
        this.MissingInput.remisebase = (this.client.remisebase === undefined || this.client.remisebase == "" ? 1 : 0)
        this.MissingInput.remisebooster = (this.client.remisebooster === undefined || this.client.remisebooster == "" ? 1 : 0)
        this.MissingInput.remisebooster9 = (this.client.remisebooster9 === undefined || this.client.remisebooster9 == "" ? 1 : 0)
        this.MissingInput.remisebooster0 = (this.client.remisebooster0 === undefined || this.client.remisebooster0 == "" ? 1 : 0)
        

        let isOneMissing = 0
        for(const key of Object.keys(this.MissingInput)) {
          if(this.MissingInput[key] == 1) {
            isOneMissing = 1
          }
        }

        return isOneMissing;
      },
      ValidateEmail() {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.client.email)) {
          this.badMail = 0
          return (false)
        }
        this.badMail = 1
        return (true)
      }
    },
    created() {
      this.initAllVar();
    },
  }
</script>

<style lang="scss">
  .nom_company {
    font-size:20px;
    font-weight: bold;
    text-transform: uppercase;
  }
  .header_client_link {
    text-transform: uppercase;
    text-decoration: underline;
    font-weight: bold;
    word-break: break-word;
    overflow-x: break-word;
    padding:10px
  }
  .active {
    color:black;
  }
  .header_client_link:last-child {
    margin-right:0
  }
  .btn-action {
    font-size:20px
  }
  hr {
    margin-top:30px
  }
  hr.hr-text {
    position: relative;
    border: none;
    height: 1px;
    background: rgb(223, 223, 223);
  }
  hr.hr-text::before {
    content: attr(data-content);
    display: inline-block;
    background: #fff;
    font-weight: bold;
    font-size: 1rem;
    color: black;
    border-radius: 30rem;
    padding: 0.2rem 1rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .information-line-name {
    text-transform: uppercase;
    font-weight: bold;
    line-height:30px
  }
  .information-line-text {
    line-height:30px
  }
  .client_block {
    border-right: 1px solid rgb(223, 223, 223);
  }
  .client_block:last-child {
    border-right: 0px solid rgb(223, 223, 223); 
  }
  .el-textarea.is-disabled .el-textarea__inner {
    color:black;
  }
</style>
